import { IconPlus } from '@tabler/icons-react'
import { ReactNode, useState } from 'react'

import { AstraButton, AstraIcon, AstraParagraph } from '~/astra'
import { PractitionerAssignment } from '~/utils/surgeryActivities'

import { StatusDefinitionForm } from './StatusDefinitionForm/StatusDefinitionForm'

export type StatusGroupProps = {
    title: string
    assignment: PractitionerAssignment
    children: ReactNode
}

export const StatusGroup = ({ title, assignment, children }: StatusGroupProps) => {
    const [openDialog, setOpenDialog] = useState(false)

    return (
        <>
            <StatusDefinitionForm key="create-form" assignmentName={assignment} open={openDialog} setOpen={setOpenDialog} />

            <div className="relative mx-4 flex flex-col gap-2">
                <div className="sticky top-0 z-elevated flex items-center justify-between rounded-md bg-neutral-subtle-rest px-3 py-2">
                    <AstraParagraph weight="medium" className="text-default">
                        {title}
                    </AstraParagraph>
                    <AstraButton
                        variant="secondary"
                        onClick={() => setOpenDialog(true)}
                        size="medium"
                        icon={<AstraIcon icon={IconPlus} size="small" />}
                        aria-label={`Legg til status i ${title}`}
                    />
                </div>

                <div className="flex flex-col gap-1">{children}</div>
            </div>
        </>
    )
}
